export class ShowMessageFromSnackbarQueueAction {
  static readonly type = '[UI] Show message from queue';

  constructor(public messageId: string) {
  }
}
